<script setup lang="ts">
defineProps<{
  variant: 'purchase' | 'success';
}>();
</script>

<template>
  <svg
    v-if="variant === 'success'"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#D1FADF" />
    <path
      d="M36 22L25 33L20 28"
      stroke="#03874C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      stroke="#ECFDF3"
      stroke-width="8"
    />
  </svg>

  <svg
    v-else
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#E0EAFF" />
    <path
      d="M28 18L31.09 24.26L38 25.27L33 30.14L34.18 37.02L28 33.77L21.82 37.02L23 30.14L18 25.27L24.91 24.26L28 18Z"
      stroke="#444CE7"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      stroke="#EEF4FF"
      stroke-width="8"
    />
  </svg>
</template>
